import {Component} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-login-failed',
    templateUrl: './login-failed.component.html',
    styleUrls: ['./login-failed.component.scss'],
    standalone: true,
    imports: [MatButton, TranslateModule]
})
export class LoginFailedComponent {

  reload() {
    window.location.href = '/';
  }

}
